import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";
import {
  extractIpFromRequest,
  runWithRequestContext,
} from "./lib/mcp/request-context";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  if (new URL(request.url).pathname.startsWith("/lovable/")) {
    return next();
  }
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Captures client IP + user agent into AsyncLocalStorage so MCP tool
// handlers (which don't receive the raw Request) can read them for
// abuse protection (rate limiting, submission logging).
const mcpRequestContextMiddleware = createMiddleware().server(
  async ({ next, request }) => {
    if (new URL(request.url).pathname.startsWith("/lovable/")) {
      return next();
    }
    return runWithRequestContext(
      {
        ip: extractIpFromRequest(request),
        userAgent: request.headers.get("user-agent"),
      },
      () => next(),
    );
  },
);

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware, mcpRequestContextMiddleware],
}));

